import styled from 'styled-components';
import Link from 'next/link';

import Button from '@components/Button/next';
import { SimpleButton } from '@components/formStyles';
import CustomIcon from '@components/utils/CustomIcon';

export const Label = styled.span<{
  bold?: boolean;
  fontSize?: number;
  center?: boolean;
  onClick?: () => void;
}>`
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
  font-size: ${({ fontSize }) => (fontSize ? `${fontSize}px` : '13px')};

  color: ${({ theme }) => theme.palette.eclipse};
  display: flex;
  ${({ center }) => center && `justify-content: center`}

  ${({ onClick }) => onClick && `cursor: pointer`}
`;

export const StyledButton = styled(Button)`
  width: 100% !important;
  height: 58px !important;
  margin-top: 41px;
  font-size: 18px !important;
  font-weight: bold;
`;

StyledButton.defaultProps = {
  variant: 'Primary',
};
export const CheckboxContainers = styled.div`
  display: flex;
  cursor: pointer;
  align-items: flex-start;
  position: relative;
`;
export const ReCaptchaContainer = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FacebookButton = styled(SimpleButton)`
  position: relative;
  width: 343px;
  height: 46px;
  margin-top: 20px;
  border-radius: 2px;
  background-color: #4267b2;

  font-size: 16px;
  text-align: center;
  color: ${({ theme }) => theme.palette.white};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #345598;
  }
  &:active {
    background-color: #274177;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
  }
`;

export const OrSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;
export const Divider = styled.div`
  margin-top: 40px;
`;

export const Line = styled.div`
  width: 94px;
  height: 1px;
  margin: 10px 10px 9px 10px;
  background-color: ${({ theme }) => theme.palette.lightBlueGrey};
`;

export const FacebookIcon = styled(CustomIcon)`
  position: absolute;
  left: 20px;
  top: 12px;
`;

export const Contract = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.coral};
  cursor: pointer;
  margin-right: 3px;
  margin-left: -10px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    margin-left: 0;
  }
`;

export const AgreementLink = styled(Link)`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.coral};
  cursor: pointer;
  margin-right: 3px;
  margin-left: -10px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    margin-left: 0;
  }
`;
export const Agreement = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.coral};
  cursor: pointer;
  margin-right: 3px;
  margin-left: -10px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    margin-left: 0;
  }
`;
export const Span = styled.span`
  font-size: 14px;
  cursor: default;
  margin-right: 3px;
  margin-left: -10px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    margin-left: 0;
  }
`;

export const ModalTitle = styled.span`
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const ErrorMessageWrapper = styled.span`
  width: 100%;
  height: 45px;
  margin-top: 17px;
  padding-left: 20px;
  display: flex;
  align-items: center;
  background-color: rgba(224, 35, 27, 0.1);
`;

export const ErrorMessage = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.coral};
  margin-left: 5px;
  margin-top: 1px;
`;

export const RequiredStar = styled.span`
  color: ${({ theme }) => theme.palette.coral};
  font-size: 15px;
  font-weight: bold;
`;

export const InformationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 10px;
  gap: 10px;

  height: 48px;
  /* Red/Red300 */
  background: #feeeed;
  border-radius: 2px;
`;

export const CountDown = styled.span<{ fontSize?: string }>`
  font-weight: 900;
  font-size: ${(props) => props.fontSize};
  line-height: 25px;
  text-align: left;
  color: ${({ theme }) => theme.palette.persianRed};
`;

export const ErrorMessageWrapperGate = styled.span`
  width: 100%;
  height: 45px;
  margin-top: 17px;
  padding-left: 20px;
  display: flex;
  align-items: center;
  background-color: rgba(224, 35, 27, 0.1);
  margin-bottom: 20px;
`;

export const ErrorMessageGate = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.coral};
  margin-left: 5px;
  margin-top: 1px;
`;

export const EtkErrorMessageWrapper = styled.div`
  width: 100%;
  height: 34px;
  padding-left: 12px;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.lightRed};
  border-radius: 2px;
`;

export const EtkErrorMessageBox = styled.span`
  color: ${(p) => p.theme.palette.persianRed};
  text-align: center;
  font-size: 12px;
  padding-left: 11.5px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const LabelReset = styled.div`
  margin: 40px 0 20px;
`;

export const Message = styled.div`
  margin-bottom: 40px;
  line-height: 1.56;
  text-align: center;
`;
export const Div = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  color: ${(p) => p.theme.palette.darkGray};
  font-size: 16px;
  line-height: 1.56;
  text-align: center;
`;
export const ResetStyledButton = styled(Button)`
  width: 470px;
  height: 58px;
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 276px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    width: 290px;
    margin-bottom: 0px;
  }
`;

export const ResetWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const DividerOtp = styled.div`
  margin-top: 10px;
`;

export const Container = styled.div`
  position: relative;
`;

export const OtpCodeWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
